// src/pages/GroupDetailsPage.jsx
import { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

const authHeader = () => ({ Authorization: `Bearer ${localStorage.getItem('token') || ''}` });
const ACADEMIC_SEMESTERS = [
    '2025/2026 zimowy',
    '2025/2026 letni',
    '2026/2027 zimowy',
    '2026/2027 letni',
];
const FIELDS_OF_STUDY = [
    'Dietetyka I stopnia',
    'Dietetyka II stopnia',
    'Fizjoterapia',
    'Kosmetologia I stopnia',
    'Kosmetologia II stopnia',
    'Pielęgniarstwo',
    'Psychologia',
    'Zdrowie publiczne',
];
const controlStyle = {
    width: '100%',
    minHeight: 40,
    padding: '8px 10px',
    border: '1px solid #d1d5db',
    borderRadius: 8,
    background: '#fff',
    boxSizing: 'border-box',
};

function GroupDetailsPage() {
    const { id: groupId } = useParams();
    const navigate = useNavigate();

    const [group, setGroup] = useState(null);
    const [terms, setTerms] = useState([]);
    const [users, setUsers] = useState([]);
    const [editing, setEditing] = useState(false);
    const [form, setForm] = useState({});
    const [editingTerm, setEditingTerm] = useState(null);
    const [formData, setFormData] = useState({
        group_id: groupId,
        exam_datetime: '',
        exam_duration: 90,
        proctoring: false
    });

    // NEW: stan na kod dołączenia
    const [joinCode, setJoinCode] = useState('');
    const [joinCodeExp, setJoinCodeExp] = useState(null);
    const [joinCodeErr, setJoinCodeErr] = useState('');
    const [joinCodeLoading, setJoinCodeLoading] = useState(false);

    async function loadJoinCode() {
        setJoinCodeLoading(true);
        setJoinCodeErr('');
        try {
            const r = await fetch(`/api/prowadzacy/grupa/${groupId}/join-code`, {
                method: 'GET',
                credentials: 'include',
                headers: { ...authHeader() }
            });
            if (!r.ok) {
                const j = await r.json().catch(() => ({}));
                throw new Error(j?.blad || `Błąd pobierania kodu (${r.status})`);
            }
            const j = await r.json(); // oczekiwane: { code, expires_at? }
            setJoinCode(j?.code || '');
            setJoinCodeExp(j?.expires_at || null);
        } catch (e) {
            setJoinCode('');
            setJoinCodeExp(null);
            setJoinCodeErr(e.message || 'Nie udało się pobrać kodu');
        } finally {
            setJoinCodeLoading(false);
        }
    }



    function copyJoinCode() {
        if (!joinCode) return;
        try {
            navigator.clipboard?.writeText(joinCode);
            // opcjonalnie krótkie potwierdzenie
        } catch {}
    }

    useEffect(() => {
        // Grupa
        fetch(`/api/prowadzacy/grupa/${groupId}`, { headers: { ...authHeader() } })
            .then(res => res.json())
            .then(data => { setGroup(data); setForm(data); })
            .catch(() => {});

        // Terminy
        fetch(`/api/prowadzacy/grupa/${groupId}/terminy`, { headers: { ...authHeader() } })
            .then(res => res.json())
            .then(setTerms)
            .catch(() => {});

        // Uczestnicy
        fetch(`/api/prowadzacy/grupa/${groupId}/uczestnicy`, { headers: { ...authHeader() } })
            .then(res => res.json())
            .then(data => Array.isArray(data) ? setUsers(data) : setUsers([]))
            .catch(() => setUsers([]));

        // NEW: pobierz kod dołączenia
        loadJoinCode();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [groupId]);

    const [now, setNow] = useState(Date.now());
    useEffect(() => {
        const id = setInterval(() => setNow(Date.now()), 30_000);
        return () => clearInterval(id);
    }, []);

    const canModifyTerm = (isoDateTime) => {
        const start = new Date(isoDateTime).getTime();
        return start > now + 15 * 60 * 1000;
    };

    const handleSave = async () => {
        await fetch(`/api/prowadzacy/grupa/${groupId}`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                ...authHeader()
            },
            body: JSON.stringify(form)
        });
        setEditing(false);
        setGroup(form);
    };

    const handleDelete = async (termId) => {
        if (!window.confirm('Na pewno usunąć ten termin?')) return;

        await fetch(`/api/prowadzacy/egzamin/termin/${termId}`, { method: 'DELETE', credentials: 'include', headers: { ...authHeader() } });
        fetch(`/api/prowadzacy/grupa/${groupId}/terminy`, { headers: { ...authHeader() } })
            .then(res => res.json())
            .then(setTerms);
    };

    const handleUpdateTerm = async () => {
        const res = await fetch(`/api/prowadzacy/egzamin/termin/${editingTerm.term_id}`, {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json', ...authHeader() },
            body: JSON.stringify(formData)
        });

        if (res.ok) {
            setEditingTerm(null);
            setFormData({ group_id: groupId, exam_datetime: '', exam_duration: 90, proctoring: false });
            fetch(`/api/prowadzacy/grupa/${groupId}/terminy`, { headers: { ...authHeader() } })
                .then(res => res.json())
                .then(setTerms);
        }
    };

    if (!group) return <p>Ładowanie...</p>;

    return (
        <div style={{ padding: '0 16px', marginTop:80 }}>
            <h2>Grupa: {group.group_name}</h2>

            {/* NEW: blok z kodem dołączenia */}
            <div style={{ border: '1px solid #e5e7eb', borderRadius: 12, padding: 12, background: '#fff', marginTop: 8, marginBottom: 16 }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 12, flexWrap: 'wrap' }}>
                    <div><strong>Kod dołączenia:</strong> {joinCodeLoading ? '…' : (joinCode || '—')}</div>
                    {joinCode && !joinCodeLoading && (
                        <button  className={'but-rozwin'} onClick={copyJoinCode} title="Kopiuj do schowka">Kopiuj</button>
                    )}
                </div>
                {joinCodeErr && <div style={{ color: '#b91c1c', marginTop: 8 }}>{joinCodeErr}</div>}
            </div>

            {editing ? (
                <div style={{ display: 'grid', gap: 10, maxWidth: 520 }}>
                    <label style={{ display: 'grid', gap: 4 }}>
                        <span>Nazwa grupy</span>
                        <input value={form.group_name || ''} onChange={e => setForm({ ...form, group_name: e.target.value })} style={controlStyle} />
                    </label>
                    <label style={{ display: 'grid', gap: 4 }}>
                        <span>Semestr</span>
                        <select value={form.semester || ''} onChange={e => setForm({ ...form, semester: e.target.value })} style={controlStyle}>
                            {ACADEMIC_SEMESTERS.map(s => <option key={s} value={s}>{s}</option>)}
                        </select>
                    </label>
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 }}>
                        <label style={{ display: 'grid', gap: 4 }}>
                            <span>Kierunek</span>
                            <select value={form.field_of_study || ''} onChange={e => setForm({ ...form, field_of_study: e.target.value })} style={controlStyle}>
                                {FIELDS_OF_STUDY.map(field => <option key={field} value={field}>{field}</option>)}
                            </select>
                        </label>
                        <label style={{ display: 'grid', gap: 4 }}>
                            <span>Tryb</span>
                            <select value={form.study_mode || ''} onChange={e => setForm({ ...form, study_mode: e.target.value })} style={controlStyle}>
                                <option value="stacjonarne">stacjonarne</option>
                                <option value="niestacjonarne">niestacjonarne</option>
                            </select>
                        </label>
                    </div>
                    <label style={{ display: 'grid', gap: 4 }}>
                        <span>Semestr studiów</span>
                        <input value={form.study_semester || ''} onChange={e => setForm({ ...form, study_semester: e.target.value })} style={controlStyle} />
                    </label>
                    <button className={'but-smal'} onClick={handleSave}> Zapisz</button>
                </div>
            ) : (
                <div>
                    <p><strong>Kierunek:</strong> {group.field_of_study}</p>
                    <p><strong>Semestr studiów:</strong> {group.study_semester}</p>
                    <p><strong>Semestr:</strong> {group.semester}</p>
                    <p><strong>Tryb:</strong> {group.study_mode}</p>
                    <button className={'but-smal'} onClick={() => setEditing(true)}>Edytuj dane grupy</button>
                </div>
            )}

            <h3 style={{ marginTop: '2rem' }}>Terminy egzaminów tej grupy</h3>
            <table border="1" cellPadding="8">
                <thead>
                <tr>
                    <th>Egzamin</th>
                    <th>Data</th>
                    <th>Czas</th>
                    <th>Nadzór</th>
                    <th>Akcje</th>
                </tr>
                </thead>
                <tbody>
                {terms.map(term => (
                    <tr key={term.term_id}>
                        <td>{term.title}</td>
                        <td>{term.exam_datetime.replace('T', ' ').slice(0, 16)}</td>
                        <td>{term.exam_duration} min</td>
                        <td>{term.proctoring ? '✅' : '❌'}</td>
                        <td>
                            {canModifyTerm(term.exam_datetime) && (
                                <>
                                    <button className={'but-smal'} onClick={() => {
                                        setEditingTerm(term);
                                        setFormData({
                                            group_id: groupId,
                                            exam_datetime: term.exam_datetime.slice(0, 16),
                                            exam_duration: term.exam_duration,
                                            proctoring: term.proctoring
                                        });
                                    }}>️ Edytuj</button>{' '}
                                    <button className={'but-smal'} onClick={() => handleDelete(term.term_id)}> Usuń</button>{' '}
                                </>
                            )}
                            <button className={'but-smal'} onClick={() => navigate(`/prowadzacy/termin/${term.term_id}/przebieg`)}>
                                 Przebieg
                            </button>
                        </td>
                    </tr>
                ))}
                </tbody>
            </table>

            {editingTerm && (
                <div style={{ marginTop: '1rem', border: '1px solid #ccc', padding: '1rem' }}>
                    <h4>Edytuj termin</h4>
                    <label>Data i godzina:</label><br />
                    <input
                        type="datetime-local"
                        value={formData.exam_datetime}
                        onChange={e => setFormData({ ...formData, exam_datetime: e.target.value })}
                    /><br />

                    <label>Czas trwania (minuty):</label><br />
                    <input
                        type="number"
                        value={formData.exam_duration}
                        onChange={e => setFormData({ ...formData, exam_duration: parseInt(e.target.value || '0', 10) })}
                    /><br />

                    <label>Nadzór:</label>
                    <input
                        type="checkbox"
                        checked={!!formData.proctoring}
                        onChange={e => setFormData({ ...formData, proctoring: e.target.checked })}
                    /><br />

                    <button className={'but-smal'} onClick={handleUpdateTerm}>Zapisz zmiany</button>{' '}
                    <button className={'but-smal'} onClick={() => setEditingTerm(null)}>Anuluj</button>
                </div>
            )}

            <h3 style={{ marginTop: '2rem' }}>Uczestnicy grupy</h3>
            <ul>
                {users.map(u => (
                    <li key={u.id}>{u.first_name} {u.last_name} ({u.indeks})</li>
                ))}
            </ul>
        </div>
    );
}

export default GroupDetailsPage;
